/**
 * 登录模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  {
    name: 'getToken',
    url: '/api/oauth/v1/realms/gsl/protocol/openid-connect/token',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  {
    name: 'getTokenSms',
    url: '/api/oauth/v1/pwd/code/authorize/token',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  {
    name: 'update',
    url: '/api/oauth/v1/user/update/password',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  {
    name: 'getUserReload',
    url: '/api/oauth/v1/user/pwd/reload',
  },
  {
    name: 'getSmsCode',
    url: '/api/oauth/v1/common/send',
    // url: '/auth/realms/operation_management/protocol/openid-connect/token',
    method: 'POST',
    defaultParams: {
      "identifier": "operation_management_person",
      "phones": "接收验证码的手机号",
      "smsToken": "前端生成一个uuid，重复使用。优先是当前设备生成唯一码，其次按浏览器生成唯一码，不行就弄成当前页面唯一码",
      "smsType": 2,
      "templateId": "register"
    }
  },
]
